// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error-container {
  height: 100vh;
  width: 50rem;
  margin: auto;
}

.error-header {
  margin-top: 8rem;
}

@media (max-width: 899px) {
  .error-container {
    width: 100vw;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ErrorClaim/ErrorClaim.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,YAAY;EACd;AACF","sourcesContent":[".error-container {\r\n  height: 100vh;\r\n  width: 50rem;\r\n  margin: auto;\r\n}\r\n\r\n.error-header {\r\n  margin-top: 8rem;\r\n}\r\n\r\n@media (max-width: 899px) {\r\n  .error-container {\r\n    width: 100vw;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
